import { Stack, Typography } from '@mui/material'
import { Check } from '@mui/icons-material'
import type { SurveyElement } from '../MidYearSummary'

interface Props {
  element: SurveyElement
  answers: Record<string, any>
}
export const SummaryCheckbox = ({ element, answers }: Props): JSX.Element => {
  const answer: string[] = Array.isArray(answers[element.name]) ? answers[element.name] : []

  return (
    <Stack gap={1}>
      <Typography variant='body1'>{element.title}</Typography>
      {answer.length > 0
        ? (
          <Stack gap={0.5}>
            {answer.map((item, index) => (
              <Stack key={index} direction='row' alignItems='center' gap={1}>
                <Check fontSize='small' color='success' />
                <Typography variant='body1' fontWeight='bold'>{item}</Typography>
              </Stack>
            ))}
          </Stack>
          )
        : <Typography variant='body1' color='text.disabled'>No items selected</Typography>
      }
    </Stack>
  )
}
